import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { SalesDocumentTemplateDeleteModal } from './SalesDocumentTemplateDeleteModal'

type SalesDocumentTemplateDeleteActivityProps = {
  refetchQuery: string
  salesDocumentTemplateId: string
}

export const SalesDocumentTemplateDeleteActivity: ActivityComponent<
  SalesDocumentTemplateDeleteActivityProps
> = (data) => {
  const { open, closeActivity } = useActivity()

  return (
    <SalesDocumentTemplateDeleteModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
      salesDocumentTemplateId={String(data.salesDocumentTemplateId)}
    />
  )
}
